import {MarkersLayerProps} from '@/map/@types';
import {AreaAnalyticsFilter} from '@/map/enums';
import {Layer} from './Layer';

const TYPES = [
  AreaAnalyticsFilter.ELEMENTARY_SCHOOL,
  AreaAnalyticsFilter.MIDDLE_SCHOOL,
  AreaAnalyticsFilter.HIGH_SCHOOL,
];

export const SchoolLayer = (props: MarkersLayerProps) => {
  return (
    <>
      {TYPES.map((type) => (
        <Layer type={type} key={type} {...props} />
      ))}
    </>
  );
};
